import { BaseEnv } from '@aipb/gulliver/env/model';
import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';
import { SetupHandler } from './setup.handler';
import { startWith, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentTitleHandler extends SetupHandler {
  private title = inject(Title);
  private transloco = inject(TranslocoService);

  constructor() {
    super('document-title.handler');
  }

  handle(env: BaseEnv) {
    this.transloco.langChanges$
      .pipe(
        startWith(this.transloco.getActiveLang()),
        tap((lang) => {
          const title = lang in env.frame.title ? env.frame.title[lang] : '<missing lang>';
          this.title.setTitle(title);
          this.addLogMessage(`set document title to ${title}`);
        })
      )
      .subscribe();
  }
}
